///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import { Component } from '@angular/core';
import { KbChartsBaseComponent } from './../charts.base.component';

@Component({
    selector: 'kb-pie-charts',
    templateUrl: './pie-charts.component.html',
})
export class KbPieChartsComponent extends KbChartsBaseComponent {}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/components/pie-charts/pie-charts.component.ts